<template>
  
 <div class="container" style="margin-top: 1em;">
    <div class="raw">
    <div class="col-1">
    </div>
    <div class="col-11">
      <v-progress-linear  v-if="store.state.waiting"  color="antiquewhite" indeterminate></v-progress-linear>
      <v-row>
        <v-col cols="1">
          <JsonToExcel v-if="['A'].find(el=>el==store.state.user.groupe)"></JsonToExcel>
        </v-col>
        <v-col cols="1">
          <v-btn density="compact" @click="refreshPrices(store.state.etablissement,store.state.date)" color="primary" ><v-icon icon="mdi-refresh"></v-icon></v-btn>   
        </v-col>
        <v-col cols="1">
          <v-btn density="compact" @click="importExport()" color="grey" ><v-icon icon="mdi-database-export-outline"></v-icon></v-btn>   
        </v-col>
      </v-row>
        <div v-for="marque in store.state.articles">
          <div v-for="theme in marque">
            <h4 style="color:grey"> {{ theme[Object.keys(theme)[0]][Object.keys(theme[Object.keys(theme)[0]])[0]].marque }} | {{ theme[Object.keys(theme)[0]][Object.keys(theme[Object.keys(theme)[0]])[0]].theme }} </h4> 
            <Theme :theme="theme"></Theme>
            <br>
            <br>
          </div>
        </div>
    </div>
  </div> 
  <v-dialog v-model="progressDialog" width="auto"
  >
    <v-progress-circular :model-value="cpt" :rotate="360" :size="100" :width="15" color="danger">
      <template v-slot:default> {{ cpt }} % </template>
    </v-progress-circular>
  </v-dialog>
   <div class="text-center pa-4">
      <v-dialog v-model="importDialog" width="600">
        <v-card title="Import Exopéra" width="600">
            <v-card-text>
              <h6> Les modifications de prix seront importés dans Exopéra à {{ getNextHalfHour() }}.</h6>
            </v-card-text>
            <template v-slot:actions>
                <v-btn
                class="ms-auto"
                text="Ok"
                @click="importDialog = false"
                ></v-btn>
            </template>
        </v-card>
      </v-dialog>
    </div>
</div> 

</template>
<script setup>
  import Theme from './Theme.vue';
  import axios from 'axios'
  import {onMounted, ref } from 'vue'
  import store from './store'
  import JsonToExcel from './JsonToExcel.vue';
  let progressDialog=ref(false)
  let cpt=ref(0)
  let importDialog=ref(false)
  async function importExport(){
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/scheduledTasksY2',
    headers: { 
        'Content-Type': 'application/json'
      }
    }

    return axios.request(config)
    .then((response) => { 
      if(response.data.statut=='ok'){
        importDialog.value=true
      }
    })
    .catch((error) => {
    //console.log(error);
    });
  }
  function getNextHalfHour(dateInput = new Date()) {
    // Conversion en objet Date si nécessaire
    const date = new Date(dateInput);
    
    // Récupérer les heures et minutes
    let hours = date.getHours();
    const minutes = date.getMinutes();
    
    // Déterminer si on passe à l'heure suivante
    if (minutes >= 30) {
      hours = (hours + 1) % 24; // % 24 pour gérer le passage à minuit
    }
    
    // Formatage avec padding à 2 chiffres pour les heures
    const formattedHours = hours.toString().padStart(2, '0');
    
    return `${formattedHours}h30`;
  }
  async function refreshPrices(etablissement,date){
    progressDialog.value=true
    let max=Object.values(store.state.articles)
      .flatMap(marque => Object.values(marque))  // Récupère tous les objets trad
      .flatMap(theme => Object.keys(theme))      // Récupère toutes les clés des trad
      .length;
    let i=0            
    for(let marque in store.state.articles){
      for (let theme in store.state.articles[marque]){
        for (let ref in store.state.articles[marque][theme]){
          cpt.value=100*(i/max).toFixed(2)
          await refreshPrice(store.state.articles[marque][theme][ref],etablissement,date)
          i++
        }
      }
    }
    progressDialog.value=false
  }
  async function getBarCodes(reference){
    let barCodes=''
    for (let barcode in reference ){
      barCodes=barCodes+`&barcodes=${reference[barcode].codebarre}`
    }
    return barCodes
  }
  async function refreshPrice(reference,etablissement,date){
    let referenceCol= reference[Object.keys(reference)[0]]
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/cegid-api/Y2/98661025_001_PROD/api/stores/${etablissement}/selling-prices/v1?taxExcluded=false&date=${date}${ await getBarCodes(reference)}`, //
      
      
      headers: { 
        'Authorization': `Bearer ${store.state.token_y2}`, 
        'Content-Type': 'application/json'
      }
    };
    // console.log(config.url);
    axios.request(config)
    .then((response) => {
      for( let price in response.data.prices){
        // if(response.data.prices[price].periodId!=store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].type_promo){
          if(response.data.prices[price].unitPrice.base!=response.data.prices[price].unitPrice.current){
            store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].prix_promo=response.data.prices[price].unitPrice.current.toFixed(1)
            store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].type_promo=response.data.prices[price].periodId
            store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].vte_euro=response.data.prices[price].unitPrice.base.toFixed(3)
          }else{
            store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].prix_promo=0
            store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].type_promo=''
            store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].vte_euro=response.data.prices[price].unitPrice.base.toFixed(3)
          }
        // }
      }
    })
    .catch((error) => {
      //console.log(error);
    })  
  }
  // onMounted(() => {
  //   console.log(store.state.etablissement);
    
  //   refreshPrices(store.state.itemsEtablissemnt.etabDEPO.etabliss.includes(store.state.etablissement)?'WEDI':store.state.etablissement, new Date().toISOString().split('T')[0])
  // })


</script>